export const START_AUTHENTICATION = "START_AUTHENTICATION";
export const SET_AUTHENTICATED = "SET_AUTHENTICATED";
export const SET_UNAUTHENTICATED = "SET_UNAUTHENTICATED";
export const SET_USER = "SET_USER";
export const SET_USER_ERRORS = "SET_USER_ERRORS";
export const ADD_FIVE_FOR_USER = "ADD_FIVE_FOR_USER";
export const ADD_TEN_FOR_USER = "ADD_TEN_FOR_USER";
export const LEVEL_UP = "LEVEL_UP";
export const UPDATE_USER_DESCRIPTION = "UPDATE_USER_DESCRIPTION";
